import { render, staticRenderFns } from "./teamMemberCard.vue?vue&type=template&id=d6034090"
import script from "./teamMemberCard.vue?vue&type=script&lang=js"
export * from "./teamMemberCard.vue?vue&type=script&lang=js"
import style0 from "./teamMemberCard.vue?vue&type=style&index=0&id=d6034090&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports